export { default as Home } from './Home';
export { default as Products } from './Products';
export { default as Product } from './Product';
export { default as AboutPage } from './AboutPage';
export { default as ContactPage } from './ContactPage';
export { default as Cart } from './Cart';
export { default as Login } from './Login';
export { default as Register } from './Register';
export { default as Checkout } from './Checkout';
export { default as PageNotFound } from './PageNotFound';
export { default as CSCenterPage} from './CSCenterPage';
export {default as FaqPage} from './FaqPage';
export {default as OrderList} from './OrderList';
export {default as CatProducts} from './CatProducts';
export {default as SuccessOrder} from './SuccessOrder';
export {default as ChangePassword} from './ChangePassword';